import logo from './assets/logo.jpg';

export const config = {
  logo,
  church_name: 'EWG Grace Temple',
  tagline: 'Dunfermline, Scotland',
  sunday_time: '2:00 PM - 4:00 PM',
  wednesday_time: '6:00 PM',
  phone_number: 'Contact us for phone number',
  email_address: 'ewggracetemple21@gmail.com',
  formspree_endpoint: 'https://formspree.io/f/mnjbelvo',
  email_registration_endpoint: 'https://formspree.io/f/mnjbelvo',
  address: ['Liberty Church', 'Liberty Centre, Pitreavie Wy, Dunfermline KY11 8QS'],
  socials: {
    facebook: 'https://www.facebook.com/share/16n9mhNCcT/?mibextid=wwXIfr',
    youtube: 'https://youtube.com/@ewggracetempledunfermline4430?si=GxsfRa-SRAMbHQ1m',
    tiktok: 'https://www.tiktok.com/@gracetemple12?_r=1&_t=ZN-93Q69peJQ7q'
  }
};
